export enum FieldColumns {
  HALF = '12, 12, 6',
  FULL = '12',
}
export enum Alignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
